import Popover from "../../core/gd-components/gd-popover/popover-v2"

// const debug = "Popovers"
const debug = false

export default class Popovers {

    popovers        : Popover[]

    constructor() {
        this.popovers = []
    }

    register(popover: Popover) {
        this.popovers.push(popover)
    }

    unregister(popover: Popover) {
        this.popovers.remove(popover)
    }

    // Popovers are absolutely positioned against a target element, and Tether re-runs that only on
    // scroll and resize. Whatever reflows the page - a validation message appearing or going away,
    // a block collapsing - moves the targets underneath them and has to call this.
    repositionAll():void {
        _.map(this.popovers, (popover : Popover) => popover?.reposition())
    }

    closeAll():void {
        debug && console.log(debug, 'closeAll', this.popovers)

        _.map(this.popovers, (popover : Popover) => {

            if (popover) {
                popover.props?.onClickOutside?.()
            } else {
                console.warn("#937262  - how come popover=", popover)
            }


        })
    }
}
